<div style="height: 80vh;" class="ui-grid ui-grid-responsive ui-fluid">
    <div style="height: 80vh;" class="ui-grid-row">
        <div class="ui-grid-col-12"  (click)=stopFollow() (contextmenu)=stopFollow() (wheel)=stopFollow()>
            <app-custom-map mapId="uteMap" (eventZoneClicked)="zoneClicked($event)" (eventVehicleClicked)="this.eventVehicleClicked.emit($event)" [pois]="pois" [zones]="zones" [options]="mapOptions" display=true ></app-custom-map>
        </div>
    </div>
</div>

<app-zone-form [realTime]=true ></app-zone-form>